import './Navbar.component.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { helpLink } from '../../../assets/constants/external-links';
import { ERoutes } from '../../../assets/constants/routes';
import logo from '../../../assets/icons/LOGO_COLORES.svg';
import { useAuth0 } from '../../../auth/auth';
import history from '../../../store/history/history';
import { LanguageSelectorComponent } from '../organisms.index';

interface IPropNavbar {
  showName?: boolean;
  showLogout?: boolean;
  showHelp?: boolean;
  hideBack?: boolean;
  hideSearch?: boolean;
  noNavigateHome?: boolean;
}

function HowItWorks() {
  return (
    <div className='help-container'>
      <a
        href={helpLink.link}
        aria-label={helpLink.name}
        target='_blank'
        rel='noopener noreferrer'
      >
        <div className='btn-icon-container d-flex justify-content-center align-items-center'>
          <FontAwesomeIcon icon='question-circle' />
        </div>
      </a>
    </div>
  );
}

export function NavbarComponent(props: IPropNavbar) {
  const { logout } = useAuth0();
  const {
    showName,
    showLogout,
    showHelp,
    hideBack,
    hideSearch,
    noNavigateHome,
  } = props;

  function back() {
    const checkHash = !!history.location.hash;
    checkHash ? history.push(ERoutes.GROUP_LIST) : history.goBack();
  }

  function navToHome() {
    if (!noNavigateHome) {
      history.push(ERoutes.HOME);
    }
  }

  function navToWishFinder() {
    history.push(ERoutes.WISH_FINDER);
  }

  return (
    <nav className='navbar home-navbar'>
      <div className='logo-container d-flex align-items-center'>
        {!hideBack && (
          <div
            className='btn-icon-container mr-3 d-flex justify-content-center align-items-center'
            onClick={() => back()}
          >
            <FontAwesomeIcon icon='chevron-left' />
          </div>
        )}
        <div onClick={() => navToHome()}>
          <img className='navbar-logo' src={logo} alt='Logo' />
        </div>
      </div>
      <div className='navbar-header'>
        {showName && <LanguageSelectorComponent />}
        {!hideSearch && (
          <div
            className='btn-icon-container d-flex justify-content-center align-items-center'
            onClick={navToWishFinder}
          >
            <FontAwesomeIcon icon='search' />
          </div>
        )}
        {showHelp && <HowItWorks />}
        {showLogout && (
          <div
            className='btn-icon-container d-flex justify-content-center align-items-center'
            onClick={() => logout()}
          >
            <FontAwesomeIcon icon='power-off' />
          </div>
        )}
      </div>
    </nav>
  );
}
